import { createReduxAsyncAction } from '../utils/toolkit';
import { TYPES } from './constants';

export const loadTenants = createReduxAsyncAction(TYPES.LOAD_TENANTS);
export const loadTenant = createReduxAsyncAction(TYPES.LOAD_TENANT);
export const createTenant = createReduxAsyncAction(TYPES.CREATE_TENANT);
export const updateTenant = createReduxAsyncAction(TYPES.UPDATE_TENANT);
export const deleteTenant = createReduxAsyncAction(TYPES.DELETE_TENANT);
export const loadTenantAdmins = createReduxAsyncAction(TYPES.LOAD_TENANT_ADMINS);
export const inviteTenantAdmin = createReduxAsyncAction(TYPES.INVITE_TENANT_ADMIN);
export const resendInviteTenantAdmin = createReduxAsyncAction(TYPES.RESEND_INVITE_TENANT_ADMIN);
export const deleteTenantAdmin = createReduxAsyncAction(TYPES.DELETE_TENANT_ADMIN);
export const getTenantAdminData = createReduxAsyncAction(TYPES.LOAD_TENANT_ADMIN_DATA);
export const registerTenantAdmin = createReduxAsyncAction(TYPES.REGISTER_TENANT_ADMIN);
export const loadStorm360Users = createReduxAsyncAction(TYPES.LOAD_STORM360_USERS);
export const loadStorm360Admins = createReduxAsyncAction(TYPES.LOAD_STORM360_ADMINS);
export const loadPendingStorm360Admins = createReduxAsyncAction(TYPES.LOAD_PENDING_STORM360_ADMINS);
export const deletePendingStorm360Admins = createReduxAsyncAction(TYPES.DELETE_PENDING_STORM360_ADMINS);
export const inviteStorm360Admin = createReduxAsyncAction(TYPES.INVITE_STORM360_ADMIN);
export const resendInviteStorm360Admin = createReduxAsyncAction(TYPES.RESEND_INVITE_STORM360_ADMIN);
export const setTenantUserStatus = createReduxAsyncAction(TYPES.SET_TENANT_USER_STATUS);
export const inviteTenantUser = createReduxAsyncAction(TYPES.INVITE_TENANT_USER);
export const inviteSharedUser = createReduxAsyncAction(TYPES.INVITE_SHARED_USER);
export const registerTenantUser = createReduxAsyncAction(TYPES.REGISTER_TENANT_USER);
export const loadTenantPendingUsers = createReduxAsyncAction(TYPES.LOAD_TENANT_PENDING_USERS);
export const resendInviteTenantUsers = createReduxAsyncAction(TYPES.RESEND_INVITE_TENANT_USERS);
export const deletePendingTenantUsers = createReduxAsyncAction(TYPES.DELETE_PENDING_TENANT_USERS);
export const loadTenantsForSharedUser = createReduxAsyncAction(TYPES.LOAD_TENANTS_FOR_SHARED_USER);
export const acceptTenantInvite = createReduxAsyncAction(TYPES.ACCEPT_TENANT_INVITE);
export const loadTenantUsersList = createReduxAsyncAction(TYPES.LOAD_TENANT_USERS_LIST);
export const uploadTenantLogo = createReduxAsyncAction(TYPES.UPLOAD_TENANT_LOGO);
export const deleteTenantLogo = createReduxAsyncAction(TYPES.DELETE_TENANT_LOGO);
